import { Content } from 'src/contexts/ContentContext';
import { vars } from 'src/core/themes';
import { Stack } from 'src/core/ui';
import { BoostIntroImage } from 'src/svgs/BoostIntroImage';
import { ContentId } from 'src/utils/constants/contentId';

import * as styles from './CampaignModal.css';

export const CampaignModalIntroBody = () => {
  return (
    <Stack
      direction="column"
      gap="xl"
      width="full"
      alignItems="center"
      className={styles.boostBodyContainer}
    >
      <BoostIntroImage />
      <span className={styles.boostSubHeaderTextSmall}>
        <Content id={ContentId.HowItWorks} />
      </span>
      <Stack
        direction="column"
        gap="l"
        alignItems="center"
        width="full"
        style={{ padding: `0 ${vars.spacing['3xl']}` }}
      >
        <Stack gap="l" alignItems="start" width="full">
          <div className={styles.boostStepNumber}>1</div>
          <Stack direction="column">
            <span className={styles.boostStepHeader}>
              <Content id={ContentId.BoostStepOneTitle} />
            </span>
            <span className={styles.boostStepDescriptions}>
              <Content id={ContentId.BoostStepOneDescription} />
            </span>
          </Stack>
        </Stack>
        <Stack gap="l" alignItems="start" width="full">
          <div className={styles.boostStepNumber}>2</div>
          <Stack direction="column">
            <span className={styles.boostStepHeader}>
              <Content id={ContentId.BoostStepTwoTitle} />
            </span>
            <span className={styles.boostStepDescriptions}>
              <Content id={ContentId.BoostStepTwoDescription} />
            </span>
          </Stack>
        </Stack>
        <Stack gap="l" alignItems="start" width="full">
          <div className={styles.boostStepNumber}>3</div>
          <Stack direction="column">
            <span className={styles.boostStepHeader}>
              <Content id={ContentId.BoostStepThreeTitle} />
            </span>
            <span className={styles.boostStepDescriptions}>
              <Content id={ContentId.BoostStepThreeDescription} />
            </span>
          </Stack>
        </Stack>
      </Stack>
    </Stack>
  );
};
